import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Chip } from "@mui/material";

export const JokerChip = () => {
  return (
    <Chip
      icon={<AutoAwesomeIcon />}
      label="Joker"
      sx={{ fontSize: "1.2rem" }}
    />
  );
};
